import React from 'react';
import { Element } from 'react-scroll';
import ContactForm from './ContactForm';

const Contact = () => {
  return (
    <>
      <ContactForm />
      <Element name="contact">
        {/* <NewsletterSubscription /> */}
      </Element>
    </>
  );
};
export default Contact;
